import { render, staticRenderFns } from "./JSPdf.vue?vue&type=template&id=0d0a6de5&scoped=true&"
import script from "./JSPdf.vue?vue&type=script&lang=js&"
export * from "./JSPdf.vue?vue&type=script&lang=js&"
import style0 from "./JSPdf.vue?vue&type=style&index=0&id=0d0a6de5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0a6de5",
  null
  
)

export default component.exports